import React, { useCallback, useEffect, useState } from 'react';
import { Card } from 'primereact/card';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { TabView, TabPanel } from 'primereact/tabview';
import { Menubar } from 'primereact/menubar';
import { Fieldset } from 'primereact/fieldset';
import { Panel } from 'primereact/panel';
import { Input, useInput, Spacer, Text, Grid } from "@nextui-org/react";
import { EditableField, NonEditableField } from './Fields.js';

import { formatDateLong, formatDateWeekday, formatToUSD } from '../../utils.js';

const Cakes = ({ cake, productProperties, editable, employees, removeCake, handleCakeChange }) => {
  const [tempCake, setTempCake] = useState(cake);

  const calculateCakePrice = useCallback((cake) => {
    let totalPrice = 0;

    // Sum up each tier's price
    cake.tiers.forEach(tier => {
      totalPrice += tier.price ? tier.price : 0;
      totalPrice += tier.premiumFillingPrice ? tier.premiumFillingPrice : 0;
      totalPrice += tier.soakPrice ? tier.soakPrice : 0;
      totalPrice += tier.extrasPrice ? tier.extrasPrice : 0;
    });

    // Add topper price if exists
    if (cake.toppers.length) {
      cake.toppers.forEach(topper => {
        totalPrice += topper.price ? topper.price : 0;
      });
    }

    if (cake.decoratingItems.length) {
      cake.decoratingItems.forEach(decoratingItem => {
        totalPrice += decoratingItem.price ? decoratingItem.price : 0;
      });
    }

    return totalPrice;
  }, []);

  const handleInputChange = useCallback((event, index, key) => {
    const value = event.target.value;

    const newCake = [...cake];
    if (!newCake[index]) {
      newCake[index] = {};
    }
    newCake[index][key] = value;
    handleCakeChange(newCake);
  }, [handleCakeChange]);

  const handleDropdownChange = useCallback((e, index, key) => {
    setTempCake(prevCake => {
      const newCake = [...prevCake];
      if (!newCake[index]) {
        newCake[index] = {};
      }
      newCake[index][key] = e.value;
      handleCakeChange(newCake);
      return newCake;
    });
  }, [handleCakeChange]);


  const handleCalendarChange = useCallback((e, index, key) => {
    setTempCake(prevCake => {
      const newCake = [...prevCake];
      if (!newCake[index]) {
        newCake[index] = {};
      }
      newCake[index][key] = e.value;
      handleCakeChange(newCake);
      return newCake;
    });
  }, [handleCakeChange]);


  useEffect(() => {
    if (cake) {
      setTempCake(cake);
    }
  }, [cake]);

  // const handleInputChange = (e, index, key) => {
  //   const value = e.target.value;

  //   setTempCake(prevCake => {
  //     const newCake = [...prevCake];
  //     if (!newCake[index]) {
  //       newCake[index] = {};
  //     }
  //     newCake[index][key] = value;
  //     handleCakeChange(newCake);
  //     return newCake;
  //   });
  // };



  const handleAddTier = (index) => {
    const newCake = [...tempCake];
    const defaultShape = productProperties[0].shapes ? Object.keys(productProperties[0].shapes)[0] : '';
    const defaultSize = defaultShape ? parseInt(productProperties[0].shapes[defaultShape][0].size) : '';

    newCake[index].tiers = [
      ...(newCake[index].tiers || []),
      {
        shape: defaultShape,
        size: defaultSize,
        layers: 3,
        // other tier properties
      }
    ];

    setTempCake(JSON.parse(JSON.stringify(newCake)));
    handleCakeChange(newCake);
  };

  const handleRemoveTier = (cakeIndex, tierIndex) => {
    const newCake = [...tempCake];
    newCake[cakeIndex].tiers = newCake[cakeIndex].tiers.filter((_, i) => i !== tierIndex);
    setTempCake(JSON.parse(JSON.stringify(newCake)));
  };

  const handleAddTopper = (index) => {
    const newCake = [...tempCake];
    newCake[index].toppers = [
      ...(newCake[index].toppers || []),
      {
        type: "Fondant"
      }
    ];

    setTempCake(JSON.parse(JSON.stringify(newCake)));
    handleCakeChange(newCake);
  };

  const handleRemoveTopper = (cakeIndex, topperIndex) => {
    const newCake = [...tempCake];
    newCake[cakeIndex].toppers = newCake[cakeIndex].toppers.filter((_, i) => i !== topperIndex);
    setTempCake(JSON.parse(JSON.stringify(newCake)));
    handleCakeChange(newCake);
  };

  const handleAddDecoratingItem = (index) => {
    const newCake = [...tempCake];
    newCake[index].decoratingItems = [
      ...(newCake[index].decoratingItems || []),
      {
        type: "Fondant"
      }
    ];
    setTempCake(JSON.parse(JSON.stringify(newCake)));
    handleCakeChange(newCake);
  };

  const handleRemoveDecoratingItem = (cakeIndex, decoratingItemIndex) => {
    const newCake = [...tempCake];
    newCake[cakeIndex].decoratingItems = newCake[cakeIndex].decoratingItems.filter((_, i) => i !== decoratingItemIndex);
    setTempCake(JSON.parse(JSON.stringify(newCake)));
    handleCakeChange(newCake);
  };

  const handleTierChange = (cakeIndex, tierIndex, key, value) => {
    const newCake = [...tempCake];
    newCake[cakeIndex].tiers[tierIndex] = { ...newCake[cakeIndex].tiers[tierIndex], [key]: value };
    setTempCake(JSON.parse(JSON.stringify(newCake)));
    handleCakeChange(newCake);
  };

  const handleTopperChange = (cakeIndex, topperIndex, key, value) => {
    const newCake = [...tempCake];
    newCake[cakeIndex].toppers[topperIndex] = { ...newCake[cakeIndex].toppers[topperIndex], [key]: value };
    setTempCake(JSON.parse(JSON.stringify(newCake)));
    handleCakeChange(newCake);
  };

  const handleDecoratingItemChange = (cakeIndex, decoratingItemIndex, key, value) => {
    const newCake = [...tempCake];
    newCake[cakeIndex].decoratingItems[decoratingItemIndex] = { ...newCake[cakeIndex].decoratingItems[decoratingItemIndex], [key]: value };
    setTempCake(JSON.parse(JSON.stringify(newCake)));
    handleCakeChange(newCake);
  };

  const getEmployeesByRole = (role) => {
    return employees.filter(employee => employee.roles.includes(role)).map(employee => ({ label: employee.name, value: employee.name }));
  };

  const cakeBoardShapeOptions = Object.keys(productProperties[0].cakeBoards).map((shape) => ({
    label: shape,
    value: shape,
  }));

  const cakeBoardSizeOptions = (item) => {
    if (item.cakeBoardShape && item.cakeBoardShape !== 'Custom') {
      const sizeOptions = productProperties[0]?.cakeBoards?.[item.cakeBoardShape]?.map((board) => ({
        label: parseInt(board.size),
        value: parseInt(board.size),
      })) || [];

      // Check if the selected size is already in the options
      const selectedSizeOption = sizeOptions.find((option) => parseInt(option.value) === parseInt(item.cakeBoardSize));

      // Add the selected size option if it's not already present
      if (selectedSizeOption) {
        return sizeOptions;
      } else {
        return [
          {
            label: parseInt(item.cakeBoardSize),
            value: parseInt(item.cakeBoardSize),
          },
          ...sizeOptions,
        ];
      }
    }

    return [];
  };
  const cakeBoardTypeOptions = (item) => {
    if (item.cakeBoardShape && item.cakeBoardShape !== 'Custom' && item.cakeBoardSize) {
      const foundBoard = productProperties[0]?.cakeBoards?.[item.cakeBoardShape]?.find(
        (board) => parseInt(board.size) === parseInt(item.cakeBoardSize)
      );

      const options = foundBoard?.types || [];

      // Check if the selected type is already in the options
      const isSelectedTypePresent = options.includes(item.cakeBoardType);

      // Add the selected type to the options if it's not already present
      if (!isSelectedTypePresent && item.cakeBoardType) {
        options.push(item.cakeBoardType);
      }

      return options
        .filter((type) => type) // Filter out any empty or falsy options
        .map((type) => ({
          label: type,
          value: type,
        }));
    }

    return [];
  };



  const items = (index) => [
    {
      label: 'Add Tier',
      icon: 'pi pi-fw pi-file',
      command: () => handleAddTier(index, tempCake?.tiers?.length ?? 0),
      style: { backgroundColor: '#ffe5ed', color: 'white', borderRadius: '10px' },
    },
    {
      label: 'Add Topper',
      icon: 'pi pi-fw pi-file',
      command: () => handleAddTopper(index, tempCake?.toppers?.length ?? 0),
      style: { backgroundColor: '#e5f4ff', color: 'white', borderRadius: '10px' },
    },
    {
      label: 'Add Decoration',
      icon: 'pi pi-fw pi-file',
      command: () => handleAddDecoratingItem(index, tempCake?.decoratingItems?.length ?? 0),
      style: { backgroundColor: '#fff3e5', color: 'white', borderRadius: '10px' },
    },
  ];



  return (
    // <Card
    // title={
    //   <div style={{
    //     //title with padding
    //     paddingTop: '0.75rem',
    //     paddingBottom: '0.75rem',
    //     paddingLeft: '1rem',
    //     paddingRight: '1rem',
    //     //border
    //     border: '1px solid #eaeaea',
    //     borderRadius: '10px',
    //     //background
    //     background: '#737373',
    //     //shadow
    //     // boxShadow: '0 0 10px rgba(0,0,0,0.1)',
    //     //margin

    //     //text
    //     textAlign: 'left',
    //     fontSize: '1.5rem',
    //     fontWeight: 'bold',
    //     color: 'white',
    //     //letter spacing
    //     letterSpacing: '0.15rem',
    //   }}>

    //     <strong>Cakes</strong>
    //   </div>
    // }
    // >
    <>
      {tempCake.map((item, index) => (
        <div
          key={index}
        style={{ marginBottom: '10px' }}>
          <Card
            key={index}
            title={
              editable ? (
                <>
                  <div style={{ justifyContent: 'space-between', display: 'flex', alignItems: 'center' }}>
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', position: 'relative' }}>
                      <EditableField
                        label="Description"
                        name="description"
                        value={item.description}
                        onChange={(e) => handleInputChange(e, index, 'description')}
                      />
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-end', position: 'relative' }}>
                      {editable && <Button className="p-button-danger" rounded onClick={() => removeCake(cake)} >Delete Cake</Button>}
                    </div>
                  </div>
                </>

              ) : (
                // Check if description exists; if not, fall back to "Cake #<n>"
                item.description === '' || !item.description ?
                  `Cake #${index + 1} - ${formatToUSD(calculateCakePrice(item))}` :
                  `${item.description} - ${formatToUSD(calculateCakePrice(item))}`
              )
            }

            style={{
              //very light gray background (almost white) - brighter than f9f9f9
              background: '#fbfbfb',
              border: '1px solid #eaeaea',
            }}
          >
            <div key={index}>


              {editable && <Menubar model={items(index)} />}

              <div style={{ marginBottom: '15px', marginTop: '15px' }}>
                {item.tiers && item.tiers.length > 0 &&
                  <Tier
                    tiers={item.tiers}
                    productProperties={productProperties}
                    editable={editable}
                    onRemove={(tierIndex) => handleRemoveTier(index, tierIndex)}
                    onChange={(tierIndex, key, value) => handleTierChange(index, tierIndex, key, value)}
                  />}

                {
                  // Check if at least one field is populated before displaying the section
                  (editable || (item.bakingNotes || item.crumbCoatingNotes || item.decoratingNotes || item.specialInstructions)) && (
                    <div style={{ flex: '1', marginRight: '10px' }}>
                      <span className="text-xl text-900 font-bold">{item.description} Notes</span>
                      <Grid.Container gap={2}>
                        {/* Check each field individually before displaying */}
                        {(editable || item.bakingNotes) && (
                          <Grid >
                            {editable ?
                              <EditableField label="Baking Notes" name="bakingNotes" value={item.bakingNotes} onChange={(e) => handleInputChange(e, index, 'bakingNotes')} />
                              :
                              <NonEditableField label="Baking Notes" value={item.bakingNotes} />
                            }
                          </Grid>
                        )}
                        {(editable || item.crumbCoatingNotes) && (
                          <Grid >
                            {editable ?
                              <EditableField label="Crumb Coating Notes" name="crumbCoatingNotes" value={item.crumbCoatingNotes} onChange={(e) => handleInputChange(e, index, 'crumbCoatingNotes')} />
                              :
                              <NonEditableField label="Crumb Coating Notes" value={item.crumbCoatingNotes} />
                            }
                          </Grid>
                        )}
                        {(editable || item.decoratingNotes) && (
                          <Grid >
                            {editable ?
                              <EditableField label="Decorating Notes" name="decoratingNotes" value={item.decoratingNotes} onChange={(e) => handleInputChange(e, index, 'decoratingNotes')} />
                              :
                              <NonEditableField label="Decorating Notes" value={item.decoratingNotes} />
                            }
                          </Grid>
                        )}
                        {(editable || item.specialInstructions) && (
                          <Grid >
                            {editable ?
                              <EditableField label="Special Instructions" name="specialInstructions" value={item.specialInstructions} onChange={(e) => handleInputChange(e, index, 'specialInstructions')} />
                              :
                              <NonEditableField label="Special Instructions" value={item.specialInstructions} />
                            }
                          </Grid>
                        )}
                      </Grid.Container>
                    </div>
                  )
                }
                {(
                  <div style={{ flex: '1', marginRight: '10px' }}>
                    <span className="text-xl text-900 font-bold">{item.description} Cake Board</span>
                    <Grid.Container gap={2}>
                      <Grid >
                        {editable || (item.cakeBoardShape && item.cakeBoardShape !== '') ? (
                          editable ?
                            <EditableField
                              label="Cake Board Shape"
                              type='dropdown'
                              name="cakeBoardShape"
                              value={item.cakeBoardShape}
                              onChange={(e) => handleInputChange(e, index, 'cakeBoardShape')}
                              options={cakeBoardShapeOptions.sort()} />
                            :
                            <NonEditableField label="Cake Board Shape" value={item.cakeBoardShape} />
                        ) : null}
                      </Grid>
                      <Grid >
                        {editable || (item.cakeBoardSize && item.cakeBoardSize !== '') ? (
                          editable ?

                            <EditableField
                              label="Cake Board Size"
                              type='dropdown'
                              name="cakeBoardSize"
                              value={item.cakeBoardSize}
                              onChange={(e) => handleInputChange(e, index, 'cakeBoardSize')}
                              options={cakeBoardSizeOptions(item).sort()} />
                            :
                            <NonEditableField label="Cake Board Size" value={item.cakeBoardSize} />
                        ) : null}
                      </Grid>
                      <Grid >
                        {editable || (item.cakeBoardType && item.cakeBoardType !== '') ? (
                          editable ?
                            <EditableField
                              label="Cake Board Type"
                              type='dropdown'
                              name="cakeBoardType"
                              value={item.cakeBoardType}
                              onChange={(e) => handleInputChange(e, index, 'cakeBoardType')}
                              options={cakeBoardTypeOptions(item).sort()} />
                            :
                            <NonEditableField label="Cake Board Type" value={item.cakeBoardType} />
                        ) : null}
                      </Grid>
                      <Grid >
                        {editable || (item.cakeBoardColor && item.cakeBoardColor !== '') ? (
                          editable ?
                            <EditableField
                              label="Cake Board Color"
                              name="cakeBoardColor"
                              value={item.cakeBoardColor}
                              onChange={(e) => handleInputChange(e, index, 'cakeBoardColor')} />
                            :
                            <NonEditableField label="Cake Board Color" value={item.cakeBoardColor} />
                        ) : null}
                         </Grid>
                      <Grid >
                        {editable || (item.cakeBoardInscription && item.cakeBoardInscription !== '') ? (
                          editable ?
                            <EditableField
                              label="Cake Board Inscription"
                              name="cakeBoardInscription"
                              value={item.cakeBoardInscription}
                              onChange={(e) => handleInputChange(e, index, 'cakeBoardInscription')} />
                            :
                            <NonEditableField label="Cake Board Inscription" value={item.cakeBoardInscription} />
                        ) : null}
                      </Grid>
                      <Grid >
                        {editable || (item.cakeBoardNote && item.cakeBoardNote !== '') ? (
                          editable ?
                            <EditableField
                              label="Cake Board Note"
                              name="cakeBoardNote"
                              value={item.cakeBoardNote}
                              onChange={(e) => handleInputChange(e, index, 'cakeBoardNote')} />
                            :
                            <NonEditableField label="Cake Board Note" value={item.cakeBoardNote} />
                        ) : null}
                      </Grid>
                    </Grid.Container>
                  </div>
                )
                }


                {item.toppers && item.toppers.length > 0 &&
                  <Topper
                    toppers={item.toppers}
                    productProperties={productProperties}
                    editable={editable}
                    onRemove={(topperIndex) => handleRemoveTopper(index, topperIndex)}
                    onChange={(topperIndex, key, value) => handleTopperChange(index, topperIndex, key, value)}
                    getEmployeesByRole={getEmployeesByRole}

                  />}
                {item.decoratingItems && item.decoratingItems.length > 0 &&
                  <DecoratingItem
                    decoratingItems={item.decoratingItems}
                    productProperties={productProperties}
                    editable={editable}
                    onRemove={(decoratingItemIndex) => handleRemoveDecoratingItem(index, decoratingItemIndex)}
                    onChange={(decoratingItemIndex, key, value) => handleDecoratingItemChange(index, decoratingItemIndex, key, value)}
                    getEmployeesByRole={getEmployeesByRole}
                  />}

              </div>

            </div>
          </Card>
        </div>
      ))}</>
    // </Card>
  );
};

const Tier = React.memo(({ tiers, productProperties, editable, onRemove, onChange }) => {
  const [selectedShape, setSelectedShape] = useState("Round");
  const [selectedSize, setSelectedSize] = useState(6);
  const [selectedLayers, setSelectedLayers] = useState(3);
  const [selectedCakeFlavor, setSelectedCakeFlavor] = useState('');
  const [selectedFilling, setSelectedFilling] = useState('');
  const [selectedPremiumFilling, setSelectedPremiumFilling] = useState('');
  const [selectedFinalIcing, setSelectedFinalIcing] = useState('');
  const [selectedExteriorIcing, setSelectedExteriorIcing] = useState('');
  const [inscription, setInscription] = useState('');
  const [selectedSoak, setSelectedSoak] = useState('');

  const shapes = Object.keys(productProperties[0].shapes);
  // console.log('Cakes.js: shapes: ', shapes);
  // console.log("productProperties: ", productProperties);
  // const sizes = selectedShape ? productProperties[0].shapes[selectedShape].map(s => parseInt(s.size)) : [];
  const sizes = selectedShape ? productProperties[0].shapes[selectedShape].map(s => `${s.size}`) : []; // Changed to ensure size is treated as a string

  // Adjusted to combine size and type, if applicable
  const sizeOptions = selectedShape ? productProperties[0].shapes[selectedShape].reduce((acc, current) => {
    const sizeLabel = current.size ? `${current.size}` : '';
    const typeLabel = current.type ? ` (${current.type})` : '';
    const label = sizeLabel + typeLabel;
    acc.push({ label, value: label });
    return acc;
  }, []) : [];


  //parseInt all sizes
  // console.log('Cakes.js: sizes: ', sizes);
  const layers = Array.from({ length: 10 }, (_, i) => i + 1);
  const cakeFlavors = productProperties[0]?.flavors.cakes;
  const fillings = productProperties[0]?.flavors.fillings;
  const premiumFillings = productProperties[0]?.flavors.premiumFillings;
  const finalIcings = productProperties[0]?.flavors.icings;
  const exteriorIcings = productProperties[0]?.flavors.decoratingIcings;
  const soaks = productProperties[0]?.flavors.soaks;

  useEffect(() => {
    // console.log('Cakes.js Change: Order.Cake.Tiers: ', tiers);
  }, [tiers]);

  return (
    <div style={{ marginBottom: '10px' }}>
      <div style={{ marginBottom: '10px' }}>
        <span className="text-xl text-900 font-bold">Tier Summary</span>
      </div>
      <DataTable value={tiers} size={"small"} style={{ width: '100%' }} showGridlines stripedRows>
        {editable || tiers.some(tier => tier.shape) ?
          <Column field="shape" header="Shape" editor={editable ? (props) =>
            <Dropdown value={props.rowData.shape} filter options={[{ label: '(None)', value: '' }, ...shapes.sort().map(shape => ({ label: shape, value: shape }))]}
              onChange={(e) => { setSelectedShape(e.value); onChange(props.rowIndex, 'shape', e.value); }} />
            : null} />
          : null}
        {/* <Column field="size" header="Size" editor={editable ? (props) =>
          <Dropdown value={props.rowData.selectedSize} filter options={sizes.sort().map(size => ({ label: size, value: size }))}
          onChange={(e) => { setSelectedSize(e.value); onChange(props.rowIndex, 'size', e.value); }} />
          : null} /> */}
        {editable || tiers.some(tier => tier.size) ?
          <Column field="size" header="Size" editor={editable ? (props) =>
            <Dropdown value={props.rowData.size} filter options={sizeOptions}
              onChange={(e) => { onChange(props.rowIndex, 'size', e.value); }} /> // Removed parseInt around e.value
            : null} />
          : null}
        {editable || tiers.some(tier => tier.layers) ?
          <Column field="layers" header="Layers" editor={editable ? (props) =>
            <Dropdown value={props.rowData.selectedLayers} filter options={[{ label: '(None)', value: '' }, ...layers.sort().map(layer => ({ label: layer, value: layer }))]}
              onChange={(e) => { setSelectedLayers(e.value); onChange(props.rowIndex, 'layers', e.value); }} />
            : null} />
          : null}
        {editable || tiers.some(tier => tier.flavor) ?
          <Column field="flavor" header="Cake Flavor" editor={editable ? (props) =>
            <Dropdown value={props.rowData.selectedCakeFlavor} filter options={[{ label: '(None)', value: '' }, ...cakeFlavors.sort().map(flavor => ({ label: flavor, value: flavor }))]}
              onChange={(e) => { setSelectedCakeFlavor(e.value); onChange(props.rowIndex, 'flavor', e.value); }} />
            : null} />
          : null}
        {editable || tiers.some(tier => tier.filling) ?
          <Column field="filling" header="Filling" editor={editable ? (props) =>
            <Dropdown value={props.rowData.selectedFilling} filter options={[{ label: '(None)', value: '' }, ...fillings.sort().map(filling => ({ label: filling, value: filling }))]}
              onChange={(e) => { setSelectedFilling(e.value); onChange(props.rowIndex, 'filling', e.value); }} />
            : null} />
          : null}
        {editable || tiers.some(tier => tier.premiumFilling) ?
          <Column field="premiumFilling" header="Premium Filling" editor={editable ? (props) =>
            <Dropdown value={props.rowData.selectedPremiumFilling} filter options={[{ label: '(None)', value: '' }, ...premiumFillings.sort().map(premiumFilling => ({ label: premiumFilling, value: premiumFilling }))]}
              onChange={(e) => { setSelectedPremiumFilling(e.value); onChange(props.rowIndex, 'premiumFilling', e.value); }} />
            : null} />
          : null}
        {editable || tiers.some(tier => tier.premiumFillingPrice) ?
          <Column field="premiumFillingPrice" header="Premium Price" editor={editable ? (props) =>
            <InputText value={tiers[props.rowIndex]?.premiumFillingPrice} onChange={(e) => { onChange(props.rowIndex, 'premiumFillingPrice', e.target.value); }} />
            : null} />
          : null}
        {editable || tiers.some(tier => tier.soak) ?
          <Column field="soak" header="Soak" editor={editable ? (props) =>
            <Dropdown value={props.rowData.selectedSoak} filter options={[{ label: '(None)', value: '' }, ...soaks.sort().map(soak => ({ label: soak, value: soak }))]}
              onChange={(e) => { setSelectedSoak(e.value); onChange(props.rowIndex, 'soak', e.value); }} />
            : null} />
          : null}
        {editable || tiers.some(tier => tier.soakPrice) ?
          <Column field="soakPrice" header="Soak Price" editor={editable ? (props) =>
            <InputText value={tiers[props.rowIndex]?.soakPrice} onChange={(e) => { onChange(props.rowIndex, 'soakPrice', e.target.value); }} />
            : null} />
          : null}
        {editable || tiers.some(tier => tier.extras) ?
          <Column field="extras" header="Extras" editor={editable ? (props) =>
            <InputText value={tiers[props.rowIndex]?.extras} onChange={(e) => { onChange(props.rowIndex, 'extras', e.target.value); }} />
            : null} />
          : null}
        {editable || tiers.some(tier => tier.extrasPrice) ?
          <Column field="extrasPrice" header="Extras Price" editor={editable ? (props) =>
            <InputText value={tiers[props.rowIndex]?.extrasPrice} onChange={(e) => { onChange(props.rowIndex, 'extrasPrice', e.target.value); }} />
            : null} />
          : null}
        {editable || tiers.some(tier => tier.finalIcing) ?
          <Column field="finalIcing" header="Crumbcoat Icing" editor={editable ? (props) =>
            <Dropdown value={props.rowData.selectedFinalIcing} filter options={[{ label: '(None)', value: '' }, ...finalIcings.sort().map(finalIcing => ({ label: finalIcing, value: finalIcing }))]}
              onChange={(e) => { setSelectedFinalIcing(e.value); onChange(props.rowIndex, 'finalIcing', e.value); }} />
            : null} />
          : null}
        {editable || tiers.some(tier => tier.exteriorIcing) ?
          <Column field="exteriorIcing" header="Exterior Finish" editor={editable ? (props) =>
            <Dropdown value={props.rowData.selectedExteriorIcing} filter options={[{ label: '(None)', value: '' }, ...exteriorIcings.sort().map(exteriorIcing => ({ label: exteriorIcing, value: exteriorIcing }))]}
              onChange={(e) => { setSelectedExteriorIcing(e.value); onChange(props.rowIndex, 'exteriorIcing', e.value); }} />
            : null} />
          : null}
        {editable || tiers.some(tier => tier.inscription) ?
          <Column field="inscription" header="Inscription" editor={editable ? (props) =>
            <InputText value={tiers[props.rowIndex]?.inscription} onChange={(e) => { setInscription(e.value); onChange(props.rowIndex, 'inscription', e.target.value); }} />
            : null} />
          : null}
        <Column field="price" header="Price" editor={editable ? (props) =>
          <InputText value={tiers[props.rowIndex]?.price} onChange={(e) => { onChange(props.rowIndex, 'price', e.target.value); }} />
          : null} />
        {editable && (
          <Column
            body={(rowData, rowIndex) => (
              <div className="p-d-flex p-justify-end">
                <Button
                  icon="pi pi-trash"
                  className="p-button-rounded p-button-danger"
                  onClick={() => onRemove(rowIndex.rowIndex)}
                />
              </div>
            )}
            style={{ textAlign: 'center', width: '8em' }}
          />
        )}
      </DataTable>

    </div>
  );
});


const Topper = React.memo(({ toppers, productProperties, editable, onRemove, onChange, getEmployeesByRole }) => {
  const [description, setDescription] = useState('');
  const [type, setType] = useState('');
  /*const [assignedPerson, setAssignedPerson] = useState('');
  const [dueDate, setDueDate] = useState(new Date());*/
  const topperTypes = productProperties[0].toppers.types;

  return (
    <div style={{ marginBottom: '10px' }}>
      <div style={{ marginBottom: '10px' }}>
        <span className="text-xl text-900 font-bold">Topper Details</span>
      </div>
      <DataTable value={toppers} size={"small"} style={{ width: '100%' }} showGridlines stripedRows >
        {editable || toppers.some(topper => topper.type) ?
          <Column
            field="type"
            header="Type"
            editor={editable ? (props) => (
              <Dropdown
                value={props.rowData.type}
                options={[{ label: '(None)', value: '' }, ...topperTypes.sort().map(type => ({ label: type, value: type }))]}
                onChange={(e) => {
                  setType(e.value);
                  onChange(props.rowIndex, 'type', e.value);
                }}
                filter
              />
            ) : null}
          />
          : null}
        {editable || toppers.some(topper => topper.description) ?
          <Column
            field="description"
            header="Description"
            editor={editable ? (props) => (
              <InputText
                value={toppers[props.rowIndex]?.description}
                onChange={(e) => {
                  setDescription(e.value);
                  onChange(props.rowIndex, 'description', e.target.value);
                }}
              />
            ) : null}
          />
          : null}
        {editable || toppers.some(topper => topper.price) ?
          <Column
            field="price"
            header="Price"
            editor={editable ? (props) => (
              <InputText
                value={toppers[props.rowIndex]?.price}
                onChange={(e) => {
                  onChange(props.rowIndex, 'price', e.target.value);
                }}
              />
            ) : null}
          />
          : null}
        {editable && (
          <Column
            body={(rowData, rowIndex) => (
              <div className="p-d-flex p-justify-end">
                <Button
                  icon="pi pi-trash"
                  className="p-button-rounded p-button-danger"
                  onClick={() => onRemove(rowIndex.rowIndex)}
                />
              </div>
            )}
            style={{ textAlign: 'center', width: '8em' }}
          />
        )}
      </DataTable>
    </div>
  );
});


const DecoratingItem = ({ decoratingItems, productProperties, editable, onRemove, onChange, getEmployeesByRole }) => {
  const [description, setDescription] = useState('');
  const [type, setType] = useState('');
  /*const [assignedPerson, setAssignedPerson] = useState('');
  const [dueDate, setDueDate] = useState(new Date());*/
  const [price, setPrice] = useState(0);
  const decorationTypes = productProperties[0].decorations.types;

  return (
    <div style={{ marginBottom: '10px' }}>
      <div style={{ marginBottom: '10px' }}>
        <span className="text-xl text-900 font-bold">Decorating Items</span>
      </div>
      <DataTable value={decoratingItems} size={"small"} style={{ width: '100%' }} showGridlines stripedRows >
        {editable || decoratingItems.some(decoratingItem => decoratingItem.type) ?
          <Column
            field="type"
            header="Type"
            editor={editable ? (props) => (
              <Dropdown
                value={props.rowData.type}
                options={[{ label: '(None)', value: '' }, ...decorationTypes.sort().map(type => ({ label: type, value: type }))]}
                onChange={(e) => {
                  setType(e.value);
                  onChange(props.rowIndex, 'type', e.value);
                }}
                filter
              />
            ) : null}
          />
          : null}
        {editable || decoratingItems.some(decoratingItem => decoratingItem.description) ?
          <Column
            field="description"
            header="Description"
            editor={editable ? (props) => (
              <InputText
                value={decoratingItems[props.rowIndex]?.description}
                onChange={(e) => {
                  setDescription(e.value);
                  onChange(props.rowIndex, 'description', e.target.value);
                }}
              />
            ) : null}
          />
          : null}

        {/*<Column
          field="assignedPerson"
          header="Assigned Person"
          editor={editable ? (props) => (
            <Dropdown
              value={props.rowData.assignedPerson}
              options={getEmployeesByRole('Decorator')}
              onChange={(e) => {
                setAssignedPerson(e.value);
                onChange(props.rowIndex, 'assignedPerson', e.value);
              }}
            />
          ) : null}
        />
        <Column
          field="dueDate"
          header="Due Date"
          body={(rowData) => rowData.dueDate ? new Date(rowData.dueDate).toLocaleDateString() : ''}
          editor={editable ? (props) => (
            <Calendar
              value={props.rowData.dueDate}
              onChange={(e) => {
                setDueDate(e.value);
                onChange(props.rowIndex, 'dueDate', e.value.toISOString());
              }}
            />
          ) : null}
            />*/}
        {editable || decoratingItems.some(decoratingItem => decoratingItem.price) ?
          <Column
            field='price'
            header='Price'
            editor={editable ? (props) => (
              <InputText
                value={decoratingItems[props.rowIndex]?.price}
                onChange={(e) => {
                  setPrice(e.value);
                  onChange(props.rowIndex, 'price', e.target.value);
                }}
              />
            ) : null}
          />
          : null}
        {editable && (
          <Column
            body={(rowData, rowIndex) => (
              <div className="p-d-flex p-justify-end">
                <Button
                  icon="pi pi-trash"
                  className="p-button-rounded p-button-danger"
                  onClick={() => onRemove(rowIndex.rowIndex)}
                />
              </div>
            )}
            style={{ textAlign: 'center', width: '8em' }}
          />
        )}
      </DataTable>
    </div>
  );
};


export default React.memo(Cakes);
